import { render, staticRenderFns } from "./XSidebarMenuDropdown.vue?vue&type=template&id=38afae2c"
import script from "./XSidebarMenuDropdown.vue?vue&type=script&lang=js"
export * from "./XSidebarMenuDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports